<template>
    <div id="headervue" style="margin-bottom: 53px">
        <div :class="['headerbox',{header_class}]">
            <div class="headercont">
                <ul class="head_menu_box">
                    <!--<li class="mg-r-70">-->
                        <!--<img @click="to_home" class="logo_img" :src="'../assets/image/index_logo.png'" style=" margin-top: -5px;" />-->
                    <!--</li>-->
                    <router-link tag="li" v-for="(v,index) in head_title" :to="v.path" :key="v.title" exact>
                        <div @click.stop>
                            <span @mouseenter="menuenter(v,index)" @mouseleave="menuleave(v,index)" @click="selectStyle(v,index,v.type)">
                                <span class="title_span" v-if="v.type != 3">
                                    {{$t(v.title)}}
                                </span>
                                <span v-else class="menu_login">
                                    <img width="w-100" src="/static/assets/image/ti_logo.png" />
                                </span>
                            </span>
                        </div>
                    </router-link>
                    <div style="clear: both;"></div>
                </ul>
                <div class="header_img">
                    <span class="sub_menu_box ico_hover" @mouseenter="menuusershow()" @mouseleave="menuuserhide()">
                        <i class="icon iconfont icon-gerenzhongxin2"></i>
                        <transition name="fade" enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown" :duration="1000">
                            <div v-if="show_center">
                                <div class="sub_menu_div user_box" @mouseenter="menuusershow()" @mouseleave="menuuserhide()">
                                    <ul v-show="menuuser_show" class="sub_menu" >
                                        <li v-if="is_login == true" @click="to_user">
                                            个人中心
                                        </li>
                                        <li v-if="is_login == true" @click="out_login">
                                            退出登录
                                        </li>
                                        <li v-if="is_login == false" @click="login">
                                            登录
                                        </li>
                                        <li v-if="is_login == false" @click="to_signup">
                                            注册
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </transition>
                    </span>
                    <!--<span class="sub_menu_box ico_hover" @mouseenter="menushow()" @mouseleave="menuhide()">-->
                        <!--&lt;!&ndash;<i @click="language('cn')" v-if="lang == 'en'" class="icon iconfont icon-zhongwen"></i>&ndash;&gt;-->
                        <!--&lt;!&ndash;<i @click="language('en')" v-if="lang == 'cn'" class="icon iconfont icon-yingwen"></i>&ndash;&gt;-->
                        <!--<i v-if="lang == 'en'" class="icon iconfont icon-zhongwen"></i>-->
                        <!--<i v-if="lang == 'cn'" class="icon iconfont icon-yingwen"></i>-->
                        <!--<transition v-if="false" name="fade" enter-active-class="animated fadeInDown" leave-active-class="animated fadeOutUp" :duration="1000">-->
                            <!--<div class="sub_menu_div language_box" @mouseenter="menushow()" @mouseleave="menuhide()">-->
                                <!--<ul v-show="menu_show" class="sub_menu " >-->
                                    <!--<li @click="language('cn')">-->
                                        <!--简体中文-->
                                    <!--</li>-->
                                    <!--&lt;!&ndash;<li @click="language('en')">&ndash;&gt;-->
                                    <!--&lt;!&ndash;ENGLISH&ndash;&gt;-->
                                    <!--&lt;!&ndash;</li>&ndash;&gt;-->
                                <!--</ul>-->
                            <!--</div>-->
                        <!--</transition>-->
                    <!--</span>-->
                </div>
            </div>
        </div>
        <div class="submenu_box">
            <transition name="fade" enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown" :duration="1000">
                <div v-if="show">
                    <div :class="['submenu',sub_class]" v-for="(v,index) in head_title" :key="index" v-if="v.selec" @mouseenter="v.selec=true;show=true" @mouseleave="v.selec=false;show=false">
                        <div class="submenu_ul">
                            <div class="erji">
                                <div class="submenu_li" v-for="(item,subindex) in v.submenu" :key="subindex" @click="go_sub(item)">
                                    {{$t(item.title)}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <div class="header_shop_box" :class="sub_class" @mouseenter="menuenter('shop',0)" @mouseleave="menuleave('shop',0)">
            <transition name="fade" enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown" :duration="300">
                <div v-if="shopShow">
                    <div class="header_shop" >
                        <div class="headerShopSwiper">
                            <el-tabs  :tab-position="tabPosition" v-model="activeHeaderName" style="height: 450px;">
                                <el-tab-pane  v-for="(item,index) in car_list" :key="index">
                                    <span class="classListBox" @mouseenter="handleClick(index)" slot="label">
                                        <span class="className">
                                            <div>{{item.class_name}}</div>
                                            <div>{{item.class_name_en}}</div>
                                        </span>
                                        <span class="classImg">
                                            <img :src="item.class_image">
                                        </span>
                                    </span>
                                    <div class="shopListBox">
                                        <div class="itemShop" v-for="(itemShop,indexShop) in item.class_list" :key="indexShop" @click="toDetails(itemShop.goods_id)">
                                            <div class="shopImgBox">
                                                <img class="w-90" :src="itemShop.goods_image" />
                                            </div>
                                            <ul class="shopUlBox">
                                                <li :style="{background:itemColor}" v-for="(itemColor,indexColor) in itemShop.color" :key="indexColor"></li>
                                            </ul>
                                        </div>
                                    </div>
                                </el-tab-pane>
                            </el-tabs>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>
<script>
    export default {
        props:[""],
        name: 'headervue',
        components:{
        },
        data () {
            return {
                route_index:0,
                activeHeaderName:'0',
                route_name:'',
                is_home:false,
                header_class:'',
                sub_class:'',
                menu_show:false,
                menuuser_show:false,
                is_login:false,
                tabPosition: 'left',
                head_title:[
                    {
                        id:1,
                        title:"message.header_menu.bigrow",
                        selec:false,
                        path:'shop',
                        type:2,
                        // submenu:[{
                        //         id:11,
                        //         title:"message.submenu_bigrow.menu01",
                        //         selec:false,
                        //         path:'shop',
                        //         type:11,
                        //     },
                        //    {
                        //         id:12,
                        //         title:"message.submenu_bigrow.menu02",
                        //         selec:false,
                        //         path:'shop',
                        //         type:12,
                        //     },
                        //     {
                        //         id:13,
                        //         title:"message.submenu_bigrow.menu03",
                        //         selec:false,
                        //         path:'shop',
                        //         type:13,
                        //     },
                        //    {
                        //         id:14,
                        //         title:"message.submenu_bigrow.menu04",
                        //         selec:false,
                        //         path:'shop',
                        //         type:14,
                        //     }]
                    },
                    {
                        id:2,
                        title:"message.header_menu.service",
                        selec:false,
                        path:'introduction',
                        type:1,
                        // submenu:[{
                        //         id:21,
                        //         title:"message.submenu_service.introduction",
                        //         selec:false,
                        //         path:'introduction',
                        //         type:21,
                        //     },
                        //     {
                        //         id:22,
                        //         title:"message.submenu_service.story",
                        //         selec:false,
                        //         path:'story',
                        //         type:22,
                        //     },
                        //     {
                        //         id:23,
                        //         title:"message.submenu_service.note",
                        //         selec:false,
                        //         path:'note',
                        //         type:23,
                        //     },
                        //     {
                        //         id:24,
                        //         title:"message.submenu_service.conversation",
                        //         selec:false,
                        //         path:'conversation',
                        //         type:24,
                        //     }]
                    },
                    {
                        id:3,
                        title:"message.header_menu.shop",
                        selec:false,
                        path:'x',
                        type:2,
                        submenu:[{
                            id:31,
                            title:"message.submenu_shop.tm_shop",
                            selec:false,
                            path:'tm_shop',
                            type:31,
                        },
                            {
                                id:32,
                                title:"message.submenu_shop.jd_shop",
                                selec:false,
                                path:'jd_shop',
                                type:32,
                            }]
                    },
                    {
                        id:4,
                        title:"首页",
                        selec:false,
                        path:'home',
                        type:3,
                        // submenu:[{
                        //         id:41,
                        //         title:"message.submenu_contact_us.dot_query",
                        //         selec:false,
                        //         path:'contact_us',
                        //         type:41,
                        //     },
                        //    {
                        //         id:42,
                        //         title:"message.submenu_contact_us.repair",
                        //         selec:false,
                        //         path:'repair',
                        //         type:42,
                        //     },
                        //     {
                        //         id:43,
                        //         title:"message.submenu_contact_us.download",
                        //         selec:false,
                        //         path:'download',
                        //         type:43,
                        //     }]
                    },
                    {
                        id:5,
                        title:"message.header_menu.contact_us",
                        selec:false,
                        path:'contact_us',
                        type:1,
                        // submenu:[{
                        //         id:41,
                        //         title:"message.submenu_contact_us.dot_query",
                        //         selec:false,
                        //         path:'contact_us',
                        //         type:41,
                        //     },
                        //    {
                        //         id:42,
                        //         title:"message.submenu_contact_us.repair",
                        //         selec:false,
                        //         path:'repair',
                        //         type:42,
                        //     },
                        //     {
                        //         id:43,
                        //         title:"message.submenu_contact_us.download",
                        //         selec:false,
                        //         path:'download',
                        //         type:43,
                        //     }]
                    },
                    {
                        id:6,
                        title:"message.header_menu.news_list",
                        selec:false,
                        path:'news',
                        type:1,
                        // submenu:[{
                        //         id:51,
                        //         title:"message.submenu_news_list.newest",
                        //         selec:false,
                        //         path:'newest',
                        //         type:51,
                        //     },
                        //    {
                        //         id:52,
                        //         title:"message.submenu_news_list.video",
                        //         selec:false,
                        //         path:'video',
                        //         type:52,
                        //     }]
                    },
                    {
                        id:7,
                        title:"message.header_menu.post_bar",
                        selec:false,
                        path:'forum',
                        type:1,
                        // submenu:[{
                        //         id:61,
                        //         title:"message.submenu_post_bar.latest_topics",
                        //         selec:false,
                        //         path:'newest',
                        //         type:61,
                        //     },
                        //     {
                        //         id:62,
                        //         title:"message.submenu_post_bar.communication",
                        //         selec:false,
                        //         path:'communication',
                        //         type:62,
                        //     },
                        //     {
                        //         id:63,
                        //         title:"message.submenu_post_bar.release",
                        //         selec:false,
                        //         path:'release',
                        //         type:63,
                        //     },
                        //     {
                        //         id:64,
                        //         title:"message.submenu_post_bar.teaching",
                        //         selec:false,
                        //         path:'teaching',
                        //         type:64,
                        //     }]
                    }
                ],
                goods_show:false,
                show:true,
                shopShow:false,
                show_center:true,
                is_goods:false,
                lang:'cn',
                cart_count_val:0,
                jb_url:'',
                tm_url:'',
                car_list:[],
            }
        },
        computed: {
            // head_title:{
            //
            // },
            cart_count() {
                return this.$store.state.cart_count_val;
            }
        },
        watch: {
            '$route'(to, from) {
                //这样就可以获取到变化的参数了，然后执行参数变化后相应的逻辑就行了
                // 将数据放在当前组件的数据内
                this.shopShow = false;
            },
            cart_count_val(val) {
                this.cart_count_val = val;
            },
            lang(newval,oldval){

            }
        },
        methods:{
            // 鼠标放入摩托车列表
            handleClick(tab){
                this.activeHeaderName = tab + '';
                console.log(this.activeHeaderName)
            },
            to_home(){
                var _this = this;
                _this.$router.push({
                    path:'/',
                    name:'home',
                })
            },
            toDetails(id){
                var _this = this;
                _this.$router.push({
                    path:'/details',
                    name:'details',
                    query:{
                        id:id
                    }
                })
            },
            handleScroll () {
                var _this = this;
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                if(scrollTop > 0){
                    _this.header_class = 'header_class';
                }else{
                    _this.header_class = '';
                }
            },
            class_show(){
                this.class_hover='flipInY animated';
            },
            class_hide(){
                this.class_hover='';
            },
            out_login(){
                var _this = this;
                _this.$confirm('是否退出登录?', '系统提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(() => {
                    _this.$store.dispatch('get_cart_count',0);
                    _this.cart_count = _this.$store.state.cart_count;
                    localStorage.clear();
                    sessionStorage.clear();
                    _this.$router.push({
                        path: '/login',
                        name: 'login',
                        // params: {
                        //     id: id
                        // }
                    })
                }).catch(() => {

                });
            },
            get_cart_count(){
                return;
                var _this = this;
                //获取购物车数量
                var key = localStorage.getItem('key');
                if(!key){
                    key = sessionStorage.getItem('key');
                }
                let url = this.config.http_url+'/index.php?m=Mobile&c=MemberCart&a=cart_count';
                let params={
                    key:key
                }
                this.$reshttp.post(url,params,{emulateJSON:true}).then(function(res){
                    if(res.body.code==200){
                        _this.$store.dispatch('get_cart_count',res.body.datas.cart_count);
                        _this.cart_count_val = _this.$store.state.cart_count_val;
                    }else{

                    }
                },function(res){
                });
            },
            popshow(){
                this.popupVisible = true;
            },
            searchshow(){
                this.search = true;
                this.search_val = '';
            },
            on_search_btn(){
                this.search = false;
            },
            onValuesChange(picker, values) {
                this.popupVisible = false;
                if (values.length>0) {
                    this.geme_name = values[0].name;
                }
            },
            //鼠标放入顶部tabbar栏
            menuenter(v,index){
                var _this = this;
                if(index == 0){
                    _this.shopShow = true;
                }else if(index == 2){
                    _this.show = true;
                    _this.head_title[index].selec = true;
                    $(".submenu").find('.submenu_li').css('height:',"30px");
                }
            },
            //鼠标移出顶部tabbar栏
            menuleave(v,index){
                var _this = this;
                if(index == 0){
                    _this.shopShow = false;
                }else if(index == 2){
                    _this.show = false;
                    _this.head_title[index].selec = false;
                    // $(".submenu").css('height:',"30px");
                }
            },
            menushow(){
                this.menu_show = true;
            },
            menuhide(){
                this.menu_show = false;
            },
            menuusershow(){
                var key = localStorage.getItem('key');
                if(!key){
                    key = sessionStorage.getItem('key');
                }
                if(!key){
                    this.is_login = false;
                }else{
                    this.is_login = true;
                }
                this.menuuser_show = true;
                this.show_center=true;
            },
            menuuserhide(){
                var key = localStorage.getItem('key');
                if(!key){
                    key = sessionStorage.getItem('key');
                }
                if(!key){
                    this.is_login = false;
                }else{
                    this.is_login = true;
                }
                this.menuuser_show = false;
                this.show_center=false;
            },
            goodsshow(val){
                this.goods_show=val;
                this.is_goods=val;
            },
            goodshide(val){
                this.goods_show=val;
                this.is_goods=val;
            },
            selectStyle(v,index,type) {
                if( type != 2){
                    for(var i=0;i<this.head_title.length;i++){
                        this.head_title[i].selec = false;
                    }
                    this.head_title[index].selec = true;
                    this.$router.push({
                        path: v.path,
                        name: v.path,
                        // params: {
                        //     id: id
                        // }
                        query: {
                            // id:v.id
                        }
                    })
                }


            },
            go_sub(v){
                var _this=this;
                if(v.type == 31){
                    if(_this.tm_url){
                        window.open(_this.tm_url);
                    }
                    return;
                }else if(v.type == 32){
                    if(_this.jb_url){
                        window.open(_this.jb_url);
                    }
                    return;
                }
                // var url = _this.config.http_url+'/index.php?m=Mobile&cIndex&a=get_setting';
                // // let theme_id = _this.theme_id;
                // var data={
                //     // key:key,
                //     // type:type,
                //     // member_id:member_id
                // }
                // _this.$reshttp.post(url, data, {emulateJSON: true}).then(function (res) {
                //     if (res.data.code == 200) {
                //
                //     } else {
                //         if(res.data.code==300){
                //             let route_query = _this.$route;
                //             _this.to_login(_this,route_query);
                //         }else{
                //             _this.open_tips(_this,"提示",res.data.datas.error);
                //         }
                //     }
                // });

                // window.open("https://tieba.baidu.com/f?fr=wwwt&kw=%E6%A3%AE%E8%93%9D%E6%96%B0%E8%83%BD%E6%BA%90%E6%91%A9%E6%89%98%E8%BD%A6");
                //
                // var _this = this;
                // _this.$router.push({
                //     path: v.path,
                //     name: v.path,
                //     // params: {
                //     //     id: id
                //     // }
                //     query: {
                //         id:v.id
                //     }
                // })
            },
            to_user(){
                this.$router.push({
                    path: '/user',
                    name: 'user',
                    // params: {
                    //     id: id
                    // }
                })
            },
            to_cart(){
                this.$router.push({
                    path: '/cart',
                    name: 'cart',
                    // params: {
                    //     id: id
                    // }
                })
            },
            login(){
                this.$router.push({
                    path: '/login',
                    name: 'login',
                    // params: {
                    //     id: id
                    // }
                })
            },
            to_signup(){
                this.$router.push({
                    path: '/signup',
                    name: 'signup',
                    // params: {
                    //     id: id
                    // }
                })
            },
            language(val){
                this.$i18n.locale = val;
                this.lang = val;
            },
            get_setting(){
                var _this = this;
                var setting = localStorage.getItem('setting');
                var setting_up_time = localStorage.getItem('setting_up_time');
                if(!setting_up_time){
                  localStorage.removeItem('setting');
                  setting = '';
                }
                if(setting){
                    setting = JSON.parse(setting);
                    _this.jb_url = setting.jd_url;
                    _this.tm_url = setting.tm_url;
                }else{
                    //url	/index.php?m=Mobile&c=Index&a=get_setting
                    var url = this.config.http_url+'/index.php?m=Mobile&c=Index&a=get_setting';
                    var params={};
                    this.$reshttp.post(url,params,{emulateJSON:true}).then(function(res){
                        if(res.body.code==200){
                            localStorage.setItem('setting',JSON.stringify(res.data.datas));
                            localStorage.setItem('setting_up_time', new Date().getTime());
                            _this.jb_url = res.data.datas.jd_url;
                            _this.tm_url = res.data.datas.tm_url;
                        }else{

                        }
                    },function(res){
                    });
                }
            },
            get_car_list(){

                var url = this.config.http_url+'/index.php?m=Mobile&c=FocusGoods&a=class_list';
                var _this = this;
                var params = {
                    params:{
                    }
                }
                this.$http.get(url,params,{emulateJSON:true}).then(res => {
                    if(res.data.code == 200){
                        _this.car_list = res.data.datas.info;
                    }else{

                    }
                },function(res){

                });


            }
        },
        beforeCreate: function(){

        },
        created: function(){

        },
        beforeMount:function(){

        },
        mounted: function(){
            var _this = this;
            _this.cart_count_val = _this.$store.state.cart_count_val;
            _this.get_cart_count();
            _this.get_car_list();
            _this.lang = this.$i18n.locale;
            var route_name = _this.$route.name;
            if(route_name=='home'){
                _this.sub_class = 'home_sub';
                _this.is_home = true;
            }else if(route_name=='offline_shop'){
                _this.sub_class = 'home_sub';
                _this.is_home = true;
            }else{
                _this.sub_class = '';
                _this.is_home = false;
            }
            _this.get_setting();
            window.addEventListener('scroll', _this.handleScroll);

        },
        beforeUpdate:function(){

        },
        updated:function(){
            var _this = this;
            _this.cart_count_val = _this.$store.state.cart_count_val;
        },
        beforeDestroy:function(){

        },
        destroyed:function(){

        }
    }

</script>
<style lang="less" type="text/less">
    .header_shop_box{
        position: fixed;
        top: 53px;
        width: 100%;
        /*left: 0px;*/
        z-index: 99;
        &.home_sub{
            top:53px;
        }
        .animated.fadeInUp.fade-enter-to{
            animation-duration:1s;
            position:relative;
            z-index: 9;
            left: auto;
        }
        .animated.fadeOutDown.fade-leave-to{
            animation-duration:1s;
            position:absolute;
            left: auto;
        }
        .fade-leave.animated.fadeOutDown{
            animation-duration:1s;
            position:absolute;
            left: auto;
        }
        .header_shop{
            width: 100%;
            padding: 50px 0 0 0;
            height: 500px;
            background: -webkit-linear-gradient(top, #403e3e , #14100f); /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(top, #403e3e, #14100f); /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(top, #403e3e, #14100f); /* Firefox 3.6 - 15 */
            background: linear-gradient(top, #403e3e , #14100f); /* 标准的语法 */

            .headerShopSwiper{
                width: 1200px;
                margin: 0 auto;
                color: #fff;
                .classListBox{
                    width: 100%;
                    .className{
                        width: calc(100% - 130px);
                        float: left;
                        display: block;
                        text-align: left;
                        padding-top: 20px;
                        &>div{
                            line-height: 20px;
                            font-style: italic;
                        }
                        &>div:first-child{
                            font-weight: bolder;
                            font-size: 16px;
                        }
                    }
                    .classImg{
                        width: 130px;
                        float: left;
                        display: block;
                        text-align: right;
                        img{
                            height: 80px;
                        }
                    }
                }
                .shopListBox{
                    overflow: hidden;
                    width: 100%;
                    /*border: 1px solid #000;*/
                    .itemShop{
                        padding: 20px 10px 0 10px;
                        width:100% / 4;
                        float: left;
                        position: relative;
                        top: 0px;
                        left: 0px;
                        text-align: center;
                        .shopImgBox{
                            cursor: pointer;
                            img{

                                transition: all 0.4s linear;
                            }
                            img:hover{
                                transform: scale(1.2);
                            }
                        }
                        .shopUlBox{
                            width: auto;
                            position: absolute;
                            bottom: 10px;
                            left: 0px;
                            right: 0px;
                            text-align: center;
                            margin: 0 auto;
                            z-index: 99;
                            li{
                                width: 20px;
                                height: 20px;
                                border-radius: 50%;
                                display: inline-block;
                                border: 5px solid #a0a1a1;
                                margin-right: 10px;
                                cursor: pointer;
                            }
                        }
                    }
                }

                .back_color_ul{
                    overflow: hidden;
                    margin: 10px 0 0 10px;
                    li{
                        width: 20px;
                        height: 20px;
                        border-radius: 50%;
                        float: left;
                        border: 3px solid #fff;
                        margin-right: 10px;
                        cursor: pointer;
                    }
                }
                .el-tabs__item{
                    height: 80px;
                    line-height: 80px;
                    color: #999;
                    img{
                        vertical-align: middle;
                        opacity: 0.7;
                        -webkit-filter: grayscale(100%);
                        -moz-filter: grayscale(100%);
                        -ms-filter: grayscale(100%);
                        -o-filter: grayscale(100%);
                        filter: grayscale(100%);
                        filter: gray;
                    }
                    img:hover{
                        transform: scale(1.05);
                        opacity: 1;
                    }
                    &.is-active,&:hover{
                        color: #fff;
                        img{
                            opacity: 1;
                            -webkit-filter: grayscale(0%);
                            -moz-filter: grayscale(0%);
                            -ms-filter: grayscale(0%);
                            -o-filter: grayscale(0%);
                            filter: grayscale(0%);
                            filter: gray;
                        }
                    }
                }
                .el-tabs__nav-wrap::after{
                    background-color: #999;
                }
                .el-tabs .el-tabs__active-bar{
                    background-color: #fff;
                }
            }
        }
    }


    .sub_menu span{
        display: none;
    }
    ul.head_menu_box >li >div >span{
        display: block;
        height: 50px;
    }
    .headerbox{
        position: fixed;
        margin: 0px auto;
        top: 0px;
        left: 0px;
        right: 0px;
        z-index: 999;
        background: #181818;
        width: 100%;
        color: #fff;
    }
    .headercont{
        width:1200px;
        margin: 0 auto;
        position: relative;
        top: 0px;
        left: 0px;
    }
    .headerbox ul.head_menu_box{
        /*overflow: hidden;*/
        width: 80%;
        float: left;
        padding-top: 2.5px;
    }
    .headerbox ul.sub_menu{
        width: 100%;
    }

    .headerbox ul.head_menu_box li{
        display: inline-block;
        float: left;
        text-align: center;
        padding:10px 0;
        height: 50px;
        cursor: pointer;
        font-size: 18px;
        width: 125px;
        &:nth-child(3),&:nth-child(7){
            span.title_span{
                border-right: 1px solid #797979;
            }
        }
        &:nth-child(4){
            width: 200px;
            padding: 0px;
            position: relative;
            top: 0px;
            left: 0px;
            span.menu_login{
                width: 90%;
                margin: 0 auto;
                display: block;
                img{
                    width: 100%;
                    opacity: 1;
                }
            }
        }
    }
    .headerbox ul.head_menu_box li.selec,
    .headerbox ul.head_menu_box li.router-link-active{
        display: inline-block;
        float: left;
        background-size: 100% 100%;
        text-align: center;
        font-weight: bold;
        color: #fff;
        font-size: 18px;
    }
    .headerbox ul.head_menu_box li span.title_span{
        border-left: 1px solid #797979;
        padding: 0px 10px;
        display: inline-block;
        color: #999;
        width: 100%;
    }
    .headerbox ul.head_menu_box li:hover span.title_span,.headerbox ul.head_menu_box li.router-link-active span.title_span{
        color: #fff;
        padding: 0px 10px;
        display: inline-block;
        font-weight: normal;
    }
    .popbox{
        width: 100%;
    }
    .search_btn{
        border-radius: 5px;
        background: #ea5415;
        color: #fff;
        padding:10px;
        margin-left: 10px;
        font-size: 14px;
    }
    .header_img{
        position: relative;
        top: 0px;
        left: 0px;
        right: 0px;
        width: 20%;
        float: right;
        text-align: right;
        cursor: pointer;
    }
    .header_img >span{
        width: 54px;
        height: 53px;
    }
    .header_img img{
        padding-top: 10px;
        margin-left: 20px;
    }
    .posi_img{
        position: absolute;
        right: 15%;
    }

    .animated{
        position: fixed;
        top: 0;
    }
    .to_cart_box{
        position: relative;

    }
    .to_cart_ico{
        position: absolute;
        top: 0px;
        right: 0px;
        color: #fff;
        border-radius: 100%;
        background: #ff1e00;
        min-width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
    }
    .sub_menu_box{
        position: relative;
        top: 0px;
        left: 0px;
        right: 0px;
        height: 53px;
    }
    .sub_menu_box >i{
        font-size: 20px;
        margin-top: 10px;
        display: inline-block;
    }
    .sub_menu_div{
        position: absolute;
        bottom: -88px;
        width: 110px;
        float: none;
        z-index: 3;
    }

    .sub_menu_div.user_box{
        right: auto;
        margin-left: -35px;
    }

    .headerbox ul.sub_menu{
        padding: 0;

    }
    .headerbox ul.sub_menu li{
        display: inline-block;
        float: left;
        text-align: center;
        padding:10px;
        cursor: pointer;
        margin-right: 10px;
        font-size: 16px;
        background: #ccc;
    }
    .headerbox .sub_menu.animated {
        position: absolute;
        padding-top: 15px;
        bottom: -100px;
        width: 150px;
        float: none;
        margin-right: -30px;
        z-index: 3;
        top: auto;
    }
    .sub_menu_box .animated.fadeInUp.fade-enter-to{
        animation-duration:1s;
        position:relative;
        z-index: 9;
        top: 13px;
        left: auto;
    }
    .sub_menu_box .animated.fadeOutDown.fade-leave-to{
        animation-duration:1s;
        position:absolute;
        top: 53px;
        left: auto;
    }
    .sub_menu_box .fade-leave.animated.fadeOutDown{
        animation-duration:1s;
        position:absolute;
        top: 53px;
        left: auto;
    }
    .submenu_box .animated.fadeInUp.fade-enter-to{
        animation-duration:1s;
        position:relative;
        z-index: 9;
        left: auto;
    }
    .submenu_box .animated.fadeOutDown.fade-leave-to{
        animation-duration:1s;
        position:absolute;
        left: auto;
    }
    .submenu_box .fade-leave.animated.fadeOutDown{
        animation-duration:1s;
        position:absolute;
        left: auto;
    }
    .headerbox .sub_menu li:hover{
        color: #fff;
        background: #666;
    }
    .headerbox .sub_menu li{
        display: block;
        width: 100%;
        color: #333;
        margin: 0;
        float: none;
    }
    .headerbox .sub_menu li:last-child{
        /*border: none;*/

    }
    .language_box{
        bottom: -45px;
    }
    #posi_img{
        cursor: pointer;
    }
    .sub_menu li{
        /*border: 1px solid #c4ebf6;*/
    }
    .header_class{
        opacity: 1;
    }
    .submenu{
        position: fixed;
        /*top: 53px;*/
        left: 0px;
        right: 0px;
        margin: 0 auto;
        z-index: 2;
        width: 1200px;
        background: rgba(51,51,51,0.8);
    }
    .submenu_ul{
        position: absolute;
        left: 258px;
        width: 110px;
        margin: 0 auto;
        overflow: hidden;
    }
    .submenu_li{
        width: 110px;
        text-align: center;
        cursor: pointer;
        float: left;
        height: 45px;
        line-height: 45px;
        color: #000;
        font-size: 16px;
        background: #ccc;
    }
    .submenu_li.selec,.submenu_li:hover{
        background: #666;
        color: #fff;
    }
    .home_sub{
        top: 53px;
    }
    .ico_hover:hover i{
        position: relative;
        -webkit-animation-duration: 1.5s;
        animation-duration: 1.5s;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
        -webkit-backface-visibility: visible!important;
        backface-visibility: visible!important;
        -webkit-animation-name: yflipInY;
        animation-name: yflipInY;
    }
    /*.erji{*/
    /*position: relative;*/
    /*-webkit-animation-duration: 1.5s;*/
    /*animation-duration: 1.5s;*/
    /*-webkit-animation-fill-mode: both;*/
    /*animation-fill-mode: both;*/
    /*-webkit-backface-visibility: visible!important;*/
    /*backface-visibility: visible!important;*/
    /*-webkit-animation-name: yflipInY;*/
    /*animation-name: yflipInY;*/
    /*}*/
    /*.ico_hover:hover .sub_menu{*/
    /*position: relative;*/
    /*-webkit-animation-duration: 1.5s;*/
    /*animation-duration: 1.5s;*/
    /*-webkit-animation-fill-mode: both;*/
    /*animation-fill-mode: both;*/
    /*-webkit-backface-visibility: visible!important;*/
    /*backface-visibility: visible!important;*/
    /*-webkit-animation-name: yflipInY;*/
    /*animation-name: yflipInY;*/
    /*}*/
    .logo_img:hover{
        position: relative;
        -webkit-animation-duration: 1.5s;
        animation-duration: 1.5s;
        -webkit-animation-fill-mode: both;
        animation-fill-mode: both;
        -webkit-backface-visibility: visible!important;
        backface-visibility: visible!important;
        -webkit-animation-name: yflipInY;
        animation-name: yflipInY;
        box-shadow: 0px 0px 5px 1px;
    }
</style>




// WEBPACK FOOTER //
// src/components/header.vue